import { render, staticRenderFns } from "./KanbanPreviewIllustration.vue?vue&type=template&id=65449e65&scoped=true"
import script from "./KanbanPreviewIllustration.vue?vue&type=script&lang=js"
export * from "./KanbanPreviewIllustration.vue?vue&type=script&lang=js"
import style0 from "./KanbanPreviewIllustration.vue?vue&type=style&index=0&id=65449e65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65449e65",
  null
  
)

export default component.exports